var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "awatar i login 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_3_11_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M186.6 217.8H83.1C68.6 217.8 59.5 201.1 66.4 187.5L87.5 146.2C90.8 139.7 97.2 135.6 104.2 135.6H163.1C169.7 135.6 175.9 139.3 179.3 145.4L202.8 186.7C210.6 200.3 201.5 217.8 186.6 217.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M134.8 114.6C155.897 114.6 173 97.4973 173 76.4C173 55.3027 155.897 38.2 134.8 38.2C113.703 38.2 96.6 55.3027 96.6 76.4C96.6 97.4973 113.703 114.6 134.8 114.6Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatarIcon.8372c7b03252d6247f78de65802f079f.svg";
export { ForwardRef as ReactComponent };